import { createFileRoute } from '@tanstack/react-router';
import { MyLearningPage } from '@/pages/learning/MyLearningPage';
import { z } from 'zod';

const learningSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	status: z.enum(['ENROLLED', 'COMPLETED', 'CANCELLED', 'NO_SHOW']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/my/learning')({
	component: MyLearningPage,
	validateSearch: learningSearchSchema,
});
